"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyPairBase = exports.addPEMExtra = exports.stripPEMExtra = void 0;
var b64_1 = __importDefault(require("./b64"));
var debug_1 = __importDefault(require("./debug"));
var debug = debug_1.default.extend('keypair');
var pem_debug = debug.extend('PEM');
/**
 * Will remove the PEM ehader and footer and line feed, compacting the key. This
 * will loose the information of what it is representing, but will and should be
 * translated in the medium that will be used to transfer it.
 * @param key key to trim
 */
function stripPEMExtra(key) {
    var parts = key.split('\n');
    var header = parts.shift();
    if (!header) {
        throw new Error('Invalid key received, no header found');
    }
    var header_match = header.match(/^-----BEGIN ([^-]+)-----$/);
    if (!header_match) {
        throw new Error('Invalid header format');
    }
    var footer = parts.pop();
    if (!footer) {
        throw new Error('Invalid key received, no footer found');
    }
    var footer_match = footer.match(/^-----END ([^-]+)-----$/);
    if (!footer_match) {
        throw new Error('Invalid footer format');
    }
    if (footer_match[1] !== header_match[1]) {
        throw new Error('Invalid payload, header and footer does not match');
    }
    var result = b64_1.default.escape(parts.join(''));
    pem_debug({
        action: 'strip',
        key: key,
        result: result,
    });
    return result;
}
exports.stripPEMExtra = stripPEMExtra;
/**
 * Re add the required information to complete the PEM format. Type is blindly
 * added, no validation is made in this function
 * @param striped value that was received from stripPEMExtra
 * @param type the type to re-add as header and footer. Should be known from
 * transfer context, no validation is made here.
 */
function addPEMExtra(striped, type) {
    var unescaped = b64_1.default.unescape(striped);
    var parts = [];
    for (var i = 0; i < unescaped.length; i += 64) {
        parts.push(unescaped.substr(i, 64));
    }
    parts.unshift("-----BEGIN " + type + "-----");
    parts.push("-----END " + type + "-----");
    var result = parts.join('\n');
    pem_debug({
        action: 'add',
        type: type,
        striped: striped,
        result: result,
    });
    return result;
}
exports.addPEMExtra = addPEMExtra;
var KeyPairBase = /** @class */ (function () {
    function KeyPairBase(prv, pub) {
        if (prv.keyid !== pub.keyid) {
            throw new Error('Invalid key pair, keyid does not match');
        }
        this._private = prv;
        this._public = pub;
        debug({
            action: 'instanciated',
            pub: pub,
            prv: prv,
        });
    }
    Object.defineProperty(KeyPairBase.prototype, "keyid", {
        get: function () {
            return this._public.keyid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyPairBase.prototype, "prv", {
        get: function () {
            return this._private;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyPairBase.prototype, "pub", {
        get: function () {
            return this._public;
        },
        enumerable: false,
        configurable: true
    });
    return KeyPairBase;
}());
exports.KeyPairBase = KeyPairBase;
